import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  SessionApproverChoice,
  type SessionApproverChoiceConstructor,
} from './SessionApproverChoice'

export const SessionApproverChoiceConstructorFactory =
  Factory.Sync.makeFactory<SessionApproverChoiceConstructor>({
    id: Factory.each(() => faker.random.number()),
    user: Factory.each(() => ({
      id: faker.random.number(),
      firstName: faker.name.firstName(),
      lastName: faker.name.lastName(),
    })),
  })

export const SessionApproverChoiceFactory = EntityFactory(
  SessionApproverChoice,
  SessionApproverChoiceConstructorFactory
)
